var __merlinGlobal = (typeof window !== 'undefined' ? window : globalThis);
var __merlinTrustedTypes = __merlinGlobal.MerlinTrustedTypes || (__merlinGlobal.MerlinTrustedTypes = (function() {
    function safeSetInnerHTML(element, html) {
        if (!element) return;
        if (!html) {
            element.replaceChildren();
            return;
        }

        var doc = new DOMParser().parseFromString('<body>' + html + '</body>', 'text/html');
        element.replaceChildren();
        Array.from(doc.body.childNodes).forEach(function(node) {
            element.appendChild(document.adoptNode(node));
        });
    }

    function safeInsertAdjacentHTML(element, position, html) {
        if (!element || !html) return;

        var doc = new DOMParser().parseFromString('<body>' + html + '</body>', 'text/html');
        var fragment = document.createDocumentFragment();
        Array.from(doc.body.childNodes).forEach(function(node) {
            fragment.appendChild(document.adoptNode(node));
        });

        switch (position) {
            case 'beforeend':
                element.appendChild(fragment);
                break;
            case 'afterbegin':
                element.prepend(fragment);
                break;
            case 'beforebegin':
                element.before(fragment);
                break;
            case 'afterend':
                element.after(fragment);
                break;
        }
    }

    return {
        safeSetInnerHTML: safeSetInnerHTML,
        safeInsertAdjacentHTML: safeInsertAdjacentHTML
    };
})());
var safeSetInnerHTML = __merlinTrustedTypes.safeSetInnerHTML;
var safeInsertAdjacentHTML = __merlinTrustedTypes.safeInsertAdjacentHTML;
/**
 * Explorer Tabs Module
 * Handles tab navigation between Graph, Timeline, Analytics, and Artefacts views
 */
(function(global) {
    'use strict';

    // Tab definitions
    const tabs = [
        { id: 'graph', label: 'Graph', icon: 'share-2' },
        { id: 'bookmarks', label: 'Bookmarks', icon: 'bookmark' },
        { id: 'timeline', label: 'Timeline', icon: 'clock' },
        { id: 'analytics', label: 'Analytics', icon: 'bar-chart-2' },
        { id: 'artefacts', label: 'Artefacts', icon: 'file-text' }
    ];

    // Current active tab
    let activeTab = 'graph';
    let tabContainer = null;
    let contentContainers = {};

    // Bottom sub-tabs bar state
    let bottomBar = null;
    let bottomBarOnly = false;
    let bottomCheckpoints = [];
    let bottomBookmarks = [];
    let activeCheckpointName = null;
    let activeBookmarkName = null;

    // ============================================
    // Initialization
    // ============================================
    function init(options = {}) {
        if (options.bottomBarOnly) {
            initBottomBar();
            return;
        }
        createTabBar();
        createContentContainers();
        createBottomSubtabs();
        bindEvents();
        
        // Set initial tab
        switchTab('graph', false);
        
        console.log('[ExplorerTabs] Initialized');
    }

    function initBottomBar() {
        bottomBarOnly = true;
        activeTab = 'graph';
        createBottomSubtabs();
        console.log('[ExplorerTabs] Initialized bottom bookmark bar');
    }

    function createTabBar() {
        // Create tab bar container
        tabContainer = document.createElement('div');
        tabContainer.id = 'explorer-tabs';
        tabContainer.className = 'explorer-tabs';
        tabContainer.setAttribute('role', 'tablist');
        tabContainer.setAttribute('aria-label', 'Explorer views');

        // Create tabs
        tabs.forEach((tab, index) => {
            const tabBtn = document.createElement('button');
            tabBtn.id = `tab-${tab.id}`;
            tabBtn.className = 'explorer-tab';
            tabBtn.setAttribute('role', 'tab');
            tabBtn.setAttribute('aria-selected', tab.id === activeTab ? 'true' : 'false');
            tabBtn.setAttribute('aria-controls', `tabpanel-${tab.id}`);
            tabBtn.setAttribute('tabindex', tab.id === activeTab ? '0' : '-1');
            tabBtn.dataset.tab = tab.id;

            safeSetInnerHTML(tabBtn, `
                <i data-lucide="${tab.icon}"></i>
                <span>${tab.label}</span>
            `);

            if (tab.id === activeTab) {
                tabBtn.classList.add('active');
            }

            tabContainer.appendChild(tabBtn);
        });

        // Insert at the top of the explorer
        const explorer = document.querySelector('.graph-explorer');
        if (explorer) {
            explorer.insertBefore(tabContainer, explorer.firstChild);
        }

        // Initialize Lucide icons for tabs
        if (typeof lucide !== 'undefined') {
            setTimeout(() => lucide.createIcons(), 10);
        }
    }

    function createContentContainers() {
        const explorer = document.querySelector('.graph-explorer');
        if (!explorer) return;

        tabs.forEach(tab => {
            // Graph and Bookmarks tabs use existing graph content
            if (tab.id === 'graph' || tab.id === 'bookmarks') {
                contentContainers['graph'] = {
                    network: document.getElementById('mynetwork'),
                    toolbar: document.getElementById('toolbar-left'),
                    timeline: document.querySelector('.timeline-container'),
                    windows: document.getElementById('floating-windows')
                };
                // Bookmarks also references the same graph content
                if (tab.id === 'bookmarks') {
                    contentContainers['bookmarks'] = contentContainers['graph'];
                }
                return;
            }

            // Create container for other tabs
            const container = document.createElement('div');
            container.id = `tabpanel-${tab.id}`;
            container.className = 'tab-content';
            container.setAttribute('role', 'tabpanel');
            container.setAttribute('aria-labelledby', `tab-${tab.id}`);
            container.style.display = 'none';

            safeSetInnerHTML(container, createTabContent(tab.id));

            explorer.appendChild(container);
            contentContainers[tab.id] = container;
        });
    }

    function createTabContent(tabId) {
        // Tab content without toolbar - main toolbar stays visible
        switch (tabId) {
            case 'timeline':
                return `
                    <div class="tab-main-content timeline-view">
                        <!-- Empty state placeholder -->
                        <div id="timeline-empty-state" class="creation-empty-state">
                            <div class="empty-state-icon timeline-empty-icon">
                                <i data-lucide="clock"></i>
                            </div>
                            <h3 class="empty-state-title">Timeline Workspaces</h3>
                            <p class="empty-state-text">Create timeline views to visualize temporal data</p>
                            <button class="empty-state-btn timeline-btn" id="timeline-empty-create-btn">
                                <i data-lucide="plus"></i>
                                Create Timeline
                            </button>
                        </div>
                        <div id="timeline-windows-container" class="timeline-windows-container"></div>
                    </div>
                `;
            case 'bookmarks':
                // Bookmarks tab uses the same graph network view - no separate content needed
                return '';
            case 'analytics':
                return `
                    <div class="tab-main-content analytics-view">
                        <!-- Empty state placeholder -->
                        <div id="analytics-empty-state" class="creation-empty-state">
                            <div class="empty-state-icon analytics-empty-icon">
                                <i data-lucide="bar-chart-2"></i>
                            </div>
                            <h3 class="empty-state-title">Analytics Workspaces</h3>
                            <p class="empty-state-text">Create MQL queries to analyze and visualize data</p>
                            <button class="empty-state-btn analytics-btn" id="analytics-empty-create-btn">
                                <i data-lucide="plus"></i>
                                Create Analytics
                            </button>
                        </div>
                        <div id="analytics-windows-container" class="analytics-windows-container"></div>
                    </div>
                `;
            case 'artefacts':
                return `
                    <div class="tab-main-content artefacts-view">
                        <!-- Empty state placeholder -->
                        <div id="artefacts-empty-state" class="creation-empty-state">
                            <div class="empty-state-icon artefacts-empty-icon">
                                <i data-lucide="file-text"></i>
                            </div>
                            <h3 class="empty-state-title">Templates & Artefacts</h3>
                            <p class="empty-state-text">Generate documents, presentations, and more from your graph data</p>
                            <button class="empty-state-btn artefacts-btn" id="artefacts-empty-create-btn">
                                <i data-lucide="plus"></i>
                                Browse Templates
                            </button>
                        </div>
                        
                        <div id="artefacts-windows-container" class="artefacts-windows-container"></div>
                    </div>
                `;
            default:
                return '';
        }
    }

    // ============================================
    // Event Handling
    // ============================================
    function bindEvents() {
        if (!tabContainer) return;

        // Tab click handler
        tabContainer.addEventListener('click', (e) => {
            const tabBtn = e.target.closest('.explorer-tab');
            if (tabBtn) {
                const tabId = tabBtn.dataset.tab;
                switchTab(tabId);
            }
        });

        // Keyboard navigation
        tabContainer.addEventListener('keydown', (e) => {
            const currentTab = document.activeElement;
            if (!currentTab.classList.contains('explorer-tab')) return;

            const tabBtns = Array.from(tabContainer.querySelectorAll('.explorer-tab'));
            const currentIndex = tabBtns.indexOf(currentTab);
            let newIndex = currentIndex;

            switch (e.key) {
                case 'ArrowLeft':
                    newIndex = currentIndex > 0 ? currentIndex - 1 : tabBtns.length - 1;
                    break;
                case 'ArrowRight':
                    newIndex = currentIndex < tabBtns.length - 1 ? currentIndex + 1 : 0;
                    break;
                case 'Home':
                    newIndex = 0;
                    break;
                case 'End':
                    newIndex = tabBtns.length - 1;
                    break;
                default:
                    return;
            }

            e.preventDefault();
            tabBtns[newIndex].focus();
            switchTab(tabBtns[newIndex].dataset.tab);
        });

        // Handle toolbar actions in other tabs
        document.addEventListener('click', (e) => {
            const actionBtn = e.target.closest('.tab-toolbar .toolbar-btn');
            if (actionBtn) {
                handleToolbarAction(actionBtn.dataset.action);
            }
        });
    }

    function handleToolbarAction(action) {
        switch (action) {
            case 'toggle-theme':
                if (typeof GraphExplorer !== 'undefined' && GraphExplorer.toggleTheme) {
                    GraphExplorer.toggleTheme();
                }
                break;
            case 'reset-view':
                console.log('[ExplorerTabs] Reset view');
                break;
            case 'reload-data':
                if (typeof ExplorerAPI !== 'undefined' && ExplorerAPI.refreshGraphData) {
                    ExplorerAPI.refreshGraphData();
                }
                break;
            case 'export':
                console.log('[ExplorerTabs] Export');
                break;
        }
    }

    // ============================================
    // Tab Switching
    // ============================================
    function switchTab(tabId, animate = true) {
        if (tabId === activeTab && animate) return;

        const previousTab = activeTab;
        activeTab = tabId;

        // Update tab buttons
        const tabBtns = tabContainer.querySelectorAll('.explorer-tab');
        tabBtns.forEach(btn => {
            const isActive = btn.dataset.tab === tabId;
            btn.classList.toggle('active', isActive);
            btn.setAttribute('aria-selected', isActive ? 'true' : 'false');
            btn.setAttribute('tabindex', isActive ? '0' : '-1');
        });

        // Update toolbar visibility - show/hide graph-only buttons
        updateToolbarForTab(tabId, animate);

        // Tabs that share floating windows with Graph tab
        const tabsWithFloatingWindows = ['graph', 'bookmarks'];
        const keepWindows = tabsWithFloatingWindows.includes(tabId);

        // Tabs that share the graph network view
        const tabsWithGraphNetwork = ['graph', 'bookmarks'];
        const keepGraphNetwork = tabsWithGraphNetwork.includes(tabId);

        // ---- Tab-specific floating window visibility ----
        // Hide windows belonging to the previous tab, restore windows for the new tab
        if (typeof ExplorerWindows !== 'undefined' && ExplorerWindows.hideWindowsForTab && ExplorerWindows.showWindowsForTab) {
            // Hide floating windows owned by the previous tab
            if (previousTab === 'graph' || previousTab === 'bookmarks') {
                ExplorerWindows.hideWindowsForTab(previousTab);
            }
            // Restore floating windows owned by the new tab
            if (tabId === 'graph' || tabId === 'bookmarks') {
                ExplorerWindows.showWindowsForTab(tabId);
            }
        }

        // Hide previous content
        if (previousTab === 'graph') {
            hideGraphContent(animate, keepWindows, keepGraphNetwork);
        } else if (previousTab === 'bookmarks') {
            // Bookmarks uses the graph network, so hide it like graph tab
            hideGraphContent(animate, keepWindows, keepGraphNetwork);
        } else if (contentContainers[previousTab]) {
            hideTabContent(contentContainers[previousTab], animate);
        }

        // Show new content
        if (tabId === 'graph') {
            showGraphContent(animate);
        } else if (tabId === 'bookmarks') {
            // Bookmarks tab shows the same graph network view as Graph tab
            showGraphContent(animate);
            // Initialize tab-specific content (e.g., bookmark-specific UI overlays)
            initializeTabContent(tabId);
            // Initialize Lucide icons in the new tab
            if (typeof lucide !== 'undefined') {
                setTimeout(() => lucide.createIcons(), 50);
            }
        } else if (contentContainers[tabId]) {
            showTabContent(contentContainers[tabId], animate);
            // Initialize tab-specific content
            initializeTabContent(tabId);
            // Initialize Lucide icons in the new tab
            if (typeof lucide !== 'undefined') {
                setTimeout(() => lucide.createIcons(), 50);
            }
        }

        // Update bottom sub-tabs visibility
        updateBottomSubtabs(tabId);

        // Announce to screen readers
        announceTabChange(tabId);

        console.log(`[ExplorerTabs] Switched to tab: ${tabId}`);
    }

    function updateToolbarForTab(tabId, animate) {
        const graphOnlyElements = document.querySelectorAll('.toolbar-graph-only');
        const bookmarksOnlyElements = document.querySelectorAll('.toolbar-bookmarks-only');
        const graphBookmarksElements = document.querySelectorAll('.toolbar-graph-bookmarks');
        const timelineOnlyElements = document.querySelectorAll('.toolbar-timeline-only');
        const analyticsOnlyElements = document.querySelectorAll('.toolbar-analytics-only');
        const artefactsOnlyElements = document.querySelectorAll('.toolbar-artefacts-only');
        const isGraphTab = tabId === 'graph';
        const isBookmarksTab = tabId === 'bookmarks';
        const isTimelineTab = tabId === 'timeline';
        const isAnalyticsTab = tabId === 'analytics';
        const isArtefactsTab = tabId === 'artefacts';
        
        // Helper to toggle elements
        function toggleElements(elements, show) {
            elements.forEach(el => {
                if (animate) {
                    el.style.transition = 'opacity 0.3s ease';
                    if (show) {
                        el.style.display = '';
                        requestAnimationFrame(() => {
                            el.style.opacity = '1';
                            el.style.maxHeight = 'none';
                        });
                    } else {
                        el.style.opacity = '0';
                        setTimeout(() => {
                            el.style.display = 'none';
                        }, 300);
                    }
                } else {
                    el.style.display = show ? '' : 'none';
                    el.style.opacity = show ? '1' : '0';
                }
            });
        }
        
        toggleElements(graphOnlyElements, isGraphTab);
        toggleElements(bookmarksOnlyElements, isBookmarksTab);
        toggleElements(graphBookmarksElements, isGraphTab || isBookmarksTab);
        toggleElements(timelineOnlyElements, isTimelineTab);
        toggleElements(analyticsOnlyElements, isAnalyticsTab);
        toggleElements(artefactsOnlyElements, isArtefactsTab);
        
        // Checkpoint/bookmark data is now pushed from _refreshSideData()
        // when /state arrives — no need to re-fetch on every tab switch.
        // Just re-render the bottom sub-tabs from cached local data.
        if (isGraphTab) {
            renderBottomItems('checkpoints', bottomCheckpoints);
        } else if (isBookmarksTab) {
            renderBottomItems('bookmarks', bottomBookmarks);
        }
    }

    function initializeTabContent(tabId) {
        switch (tabId) {
            case 'timeline':
                initTimelineTab();
                break;
            case 'analytics':
                initAnalyticsTab();
                break;
            case 'bookmarks':
                // Future: initialize bookmarks
                break;
            case 'artefacts':
                initArtefactsTab();
                break;
        }
    }

    // ============================================
    // Timeline Tab - Window Management
    // ============================================
    let timelineWindows = {};
    let timelineWindowCount = 0;
    let activeTimelineWindow = null;
    let timelineDragState = null;
    let timelineResizeState = null;

    function initTimelineTab() {
        // Bind empty state create button - directly creates a window
        const emptyCreateBtn = document.getElementById('timeline-empty-create-btn');
        if (emptyCreateBtn && !emptyCreateBtn.dataset.bound) {
            emptyCreateBtn.addEventListener('click', () => {
                createTimelineWindow(`Timeline ${timelineWindowCount + 1}`);
            });
            emptyCreateBtn.dataset.bound = 'true';
        }
        
        // Bind toolbar create button
        const toolbarBtn = document.getElementById('btn-create-timeline');
        if (toolbarBtn && !toolbarBtn.dataset.bound) {
            toolbarBtn.addEventListener('click', () => {
                createTimelineWindow(`Timeline ${timelineWindowCount + 1}`);
            });
            toolbarBtn.dataset.bound = 'true';
        }
        
        // Initialize Lucide icons
        if (typeof lucide !== 'undefined') {
            setTimeout(() => lucide.createIcons(), 50);
        }
        
        // Update empty state visibility
        updateTimelineEmptyState();
    }

    function updateTimelineEmptyState() {
        const emptyState = document.getElementById('timeline-empty-state');
        const hasWindows = Object.keys(timelineWindows).length > 0;
        if (emptyState) {
            emptyState.style.display = hasWindows ? 'none' : 'flex';
        }
    }

    function createTimelineWindow(name, description = '') {
        timelineWindowCount++;
        const windowId = `timeline-win-${timelineWindowCount}`;
        
        // Calculate position - center the window
        const containerRect = document.querySelector('.timeline-view')?.getBoundingClientRect() || { width: 800, height: 600 };
        const windowWidth = 800;
        const windowHeight = 450;
        const offset = (timelineWindowCount - 1) * 30;
        const baseLeft = Math.max(80, (containerRect.width - windowWidth) / 2 + offset);
        const baseTop = Math.max(60, (containerRect.height - windowHeight) / 2 + offset);
        
        const win = document.createElement('div');
        win.id = windowId;
        win.className = 'timeline-window';
        win.dataset.windowId = windowId;
        win.style.left = baseLeft + 'px';
        win.style.top = baseTop + 'px';
        win.style.width = windowWidth + 'px';
        win.style.height = windowHeight + 'px';

        safeSetInnerHTML(win, `
            <div class="timeline-window-header" data-drag="true">
                <span class="timeline-window-icon"><i data-lucide="clock"></i></span>
                <input type="text" class="timeline-window-title-input" 
                       value="${escapeHtml(name)}" 
                       placeholder="Timeline name..."
                       data-window-id="${windowId}">
                <div class="timeline-window-actions">
                    <button class="timeline-window-btn" data-action="minimize" title="Minimize">
                        <i data-lucide="minus"></i>
                    </button>
                    <button class="timeline-window-btn" data-action="maximize" title="Maximize">
                        <i data-lucide="maximize-2"></i>
                    </button>
                    <button class="timeline-window-btn close" data-action="close" title="Close">
                        <i data-lucide="x"></i>
                    </button>
                </div>
            </div>
            <div class="timeline-window-content">
                <div id="${windowId}-timeline" class="timeline-window-vis"></div>
            </div>
            <div class="timeline-window-resize" data-resize="true"></div>
        `);

        // Add to container
        const container = document.getElementById('timeline-windows-container');
        if (container) {
            container.appendChild(win);
        }

        // Store reference
        timelineWindows[windowId] = {
            element: win,
            name: name,
            timeline: null,
            isMinimized: false,
            isMaximized: false
        };

        // Bind events
        bindTimelineWindowEvents(win);
        
        // Bind title input change to update toolbar
        const titleInput = win.querySelector('.timeline-window-title-input');
        if (titleInput) {
            titleInput.addEventListener('change', (e) => {
                const newName = e.target.value.trim() || `Timeline ${timelineWindowCount}`;
                timelineWindows[windowId].name = newName;
                if (typeof ExplorerToolbar !== 'undefined' && ExplorerToolbar.updateTimelineInList) {
                    ExplorerToolbar.updateTimelineInList(windowId, newName);
                }
            });
            // Focus the title input for immediate editing
            setTimeout(() => titleInput.select(), 100);
        }

        // Initialize the timeline visualization
        setTimeout(() => {
            initTimelineInWindow(windowId);
            if (typeof lucide !== 'undefined') {
                lucide.createIcons();
            }
        }, 100);

        // Add to toolbar list
        if (typeof ExplorerToolbar !== 'undefined' && ExplorerToolbar.addTimelineToList) {
            ExplorerToolbar.addTimelineToList(windowId, name);
        }

        // Bring to front
        bringTimelineWindowToFront(windowId);
        
        // Update empty state
        updateTimelineEmptyState();

        console.log(`[ExplorerTabs] Created timeline window: ${name}`);
        return windowId;
    }
    
    function focusTimelineWindow(windowId) {
        const winData = timelineWindows[windowId];
        if (winData && winData.element) {
            // Restore if minimized
            if (winData.isMinimized) {
                winData.element.classList.remove('minimized');
                winData.isMinimized = false;
            }
            bringTimelineWindowToFront(windowId);
            winData.element.scrollIntoView({ behavior: 'smooth', block: 'center' });
        }
    }

    function bindTimelineWindowEvents(win) {
        const header = win.querySelector('.timeline-window-header');
        const resizeHandle = win.querySelector('.timeline-window-resize');

        // Drag handling
        header.addEventListener('mousedown', (e) => {
            if (e.target.closest('.timeline-window-btn')) return;
            
            timelineDragState = {
                windowId: win.dataset.windowId,
                startX: e.clientX,
                startY: e.clientY,
                startLeft: win.offsetLeft,
                startTop: win.offsetTop
            };
            
            bringTimelineWindowToFront(win.dataset.windowId);
            e.preventDefault();
        });

        // Resize handling
        resizeHandle.addEventListener('mousedown', (e) => {
            timelineResizeState = {
                windowId: win.dataset.windowId,
                startX: e.clientX,
                startY: e.clientY,
                startWidth: win.offsetWidth,
                startHeight: win.offsetHeight
            };
            
            e.preventDefault();
        });

        // Button actions
        win.addEventListener('click', (e) => {
            const btn = e.target.closest('.timeline-window-btn');
            if (!btn) return;
            
            const action = btn.dataset.action;
            const windowId = win.dataset.windowId;
            
            switch (action) {
                case 'close':
                    closeTimelineWindow(windowId);
                    break;
                case 'minimize':
                    toggleMinimizeTimelineWindow(windowId);
                    break;
                case 'maximize':
                    toggleMaximizeTimelineWindow(windowId);
                    break;
            }
        });

        // Click to bring to front
        win.addEventListener('mousedown', () => {
            bringTimelineWindowToFront(win.dataset.windowId);
        });
    }

    // Global mouse events for dragging/resizing
    document.addEventListener('mousemove', (e) => {
        if (timelineDragState) {
            const win = document.getElementById(timelineDragState.windowId);
            if (win) {
                const dx = e.clientX - timelineDragState.startX;
                const dy = e.clientY - timelineDragState.startY;
                win.style.left = (timelineDragState.startLeft + dx) + 'px';
                win.style.top = (timelineDragState.startTop + dy) + 'px';
            }
        }
        
        if (timelineResizeState) {
            const win = document.getElementById(timelineResizeState.windowId);
            if (win) {
                const dx = e.clientX - timelineResizeState.startX;
                const dy = e.clientY - timelineResizeState.startY;
                const newWidth = Math.max(400, timelineResizeState.startWidth + dx);
                const newHeight = Math.max(250, timelineResizeState.startHeight + dy);
                win.style.width = newWidth + 'px';
                win.style.height = newHeight + 'px';
                
                // Resize timeline
                const windowData = timelineWindows[timelineResizeState.windowId];
                if (windowData && windowData.timeline) {
                    windowData.timeline.redraw();
                }
            }
        }
    });

    document.addEventListener('mouseup', () => {
        timelineDragState = null;
        timelineResizeState = null;
    });

    function closeTimelineWindow(windowId) {
        const windowData = timelineWindows[windowId];
        if (!windowData) return;
        
        // Destroy timeline
        if (windowData.timeline) {
            windowData.timeline.destroy();
        }
        
        // Remove element
        windowData.element.remove();
        
        // Remove from registry
        delete timelineWindows[windowId];
        
        // Remove from toolbar list
        if (typeof ExplorerToolbar !== 'undefined' && ExplorerToolbar.removeTimelineFromList) {
            ExplorerToolbar.removeTimelineFromList(windowId);
        }
        
        // Update empty state
        updateTimelineEmptyState();
    }

    function toggleMinimizeTimelineWindow(windowId) {
        const windowData = timelineWindows[windowId];
        if (!windowData) return;
        
        windowData.isMinimized = !windowData.isMinimized;
        windowData.element.classList.toggle('minimized', windowData.isMinimized);
    }

    function toggleMaximizeTimelineWindow(windowId) {
        const windowData = timelineWindows[windowId];
        if (!windowData) return;
        
        windowData.isMaximized = !windowData.isMaximized;
        windowData.element.classList.toggle('maximized', windowData.isMaximized);
        
        // Redraw timeline
        if (windowData.timeline) {
            setTimeout(() => windowData.timeline.redraw(), 100);
        }
    }

    function bringTimelineWindowToFront(windowId) {
        const maxZ = Object.values(timelineWindows).reduce((max, w) => {
            const z = parseInt(w.element.style.zIndex || 0);
            return Math.max(max, z);
        }, 0);
        
        const windowData = timelineWindows[windowId];
        if (windowData) {
            windowData.element.style.zIndex = maxZ + 1;
        }
    }

    function initTimelineInWindow(windowId) {
        const container = document.getElementById(`${windowId}-timeline`);
        if (!container) return;

        // Check if vis-timeline is available
        if (typeof vis === 'undefined' || !vis.Timeline) {
            console.warn('[ExplorerTabs] vis-timeline library not loaded, showing placeholder');
            safeSetInnerHTML(container, `
                <div class="timeline-placeholder">
                    <i data-lucide="clock"></i>
                    <span>Timeline visualization</span>
                    <small>vis-timeline library not loaded</small>
                </div>
            `);
            if (typeof lucide !== 'undefined') lucide.createIcons();
            return;
        }

        // Apply theme class
        const isDark = !document.querySelector('.graph-explorer').classList.contains('light-theme');
        container.classList.add(isDark ? 'timeline-dark' : 'timeline-light');

        // Generate sample data
        const groupCount = 8;
        const itemCount = 50;
        const now = new Date();

        // Create groups
        const groups = new vis.DataSet();
        const groupLabels = ['Events', 'Tasks', 'Milestones', 'Meetings', 'Deadlines', 'Reviews', 'Releases', 'Other'];
        for (let g = 0; g < groupCount; g++) {
            groups.add({ id: g, content: groupLabels[g] || `Group ${g}` });
        }

        // Item types
        const types = ['point', 'range', 'box', 'background'];
        const typeWeights = [0.3, 0.4, 0.2, 0.1];

        // Create items
        const items = new vis.DataSet();
        for (let i = 0; i < itemCount; i++) {
            const startOffset = Math.random() * 180;
            const start = new Date(now.getTime() + startOffset * 24 * 60 * 60 * 1000);
            const endOffset = Math.random() * 30;
            const end = new Date(start.getTime() + endOffset * 24 * 60 * 60 * 1000);
            const group = Math.floor(Math.random() * groupCount);
            
            let type = types[0];
            let rand = Math.random();
            let cumWeight = 0;
            for (let t = 0; t < types.length; t++) {
                cumWeight += typeWeights[t];
                if (rand < cumWeight) { type = types[t]; break; }
            }

            items.add({
                id: i,
                type: type,
                group: group,
                content: `Item ${i}`,
                start: start,
                end: type === 'range' || type === 'background' ? end : undefined,
            });
        }

        // Timeline options
        const options = {
            start: new Date(now.getTime() - 7 * 24 * 60 * 60 * 1000),
            end: new Date(now.getTime() + 60 * 24 * 60 * 60 * 1000),
            height: '100%',
            min: new Date(now.getTime() - 30 * 24 * 60 * 60 * 1000),
            max: new Date(now.getTime() + 365 * 24 * 60 * 60 * 1000),
            zoomMin: 1000 * 60 * 60 * 24,
            zoomMax: 1000 * 60 * 60 * 24 * 365,
            orientation: 'top',
            showCurrentTime: true,
            showTooltips: true,
            stack: true,
            verticalScroll: true,
            horizontalScroll: true,
            zoomKey: 'ctrlKey',
        };

        // Create timeline
        const timeline = new vis.Timeline(container, items, groups, options);
        
        // Store reference
        timelineWindows[windowId].timeline = timeline;
    }

    function escapeHtml(text) {
        const div = document.createElement('div');
        div.textContent = text;
        return div.innerHTML;
    }

    // ============================================
    // Analytics Tab - MQL Query Windows
    // ============================================
    let analyticsWindows = {};
    let analyticsWindowCount = 0;
    let activeAnalyticsWindow = null;
    let analyticsDragState = null;
    let analyticsResizeState = null;

    function initAnalyticsTab() {
        // Bind empty state create button - directly creates a window
        const emptyCreateBtn = document.getElementById('analytics-empty-create-btn');
        if (emptyCreateBtn && !emptyCreateBtn.dataset.bound) {
            emptyCreateBtn.addEventListener('click', () => {
                createAnalyticsWindow(`Analytics ${analyticsWindowCount + 1}`);
            });
            emptyCreateBtn.dataset.bound = 'true';
        }
        
        // Bind toolbar create button
        const toolbarBtn = document.getElementById('btn-create-analytics');
        if (toolbarBtn && !toolbarBtn.dataset.bound) {
            toolbarBtn.addEventListener('click', () => {
                createAnalyticsWindow(`Analytics ${analyticsWindowCount + 1}`);
            });
            toolbarBtn.dataset.bound = 'true';
        }
        
        // Initialize Lucide icons
        if (typeof lucide !== 'undefined') {
            setTimeout(() => lucide.createIcons(), 50);
        }
        
        // Update empty state visibility
        updateAnalyticsEmptyState();
    }

    function updateAnalyticsEmptyState() {
        const emptyState = document.getElementById('analytics-empty-state');
        const hasWindows = Object.keys(analyticsWindows).length > 0;
        if (emptyState) {
            emptyState.style.display = hasWindows ? 'none' : 'flex';
        }
    }

    function createAnalyticsWindow(name, initialMql = '', outputType = 'table') {
        analyticsWindowCount++;
        const windowId = `analytics-window-${analyticsWindowCount}`;
        
        // Calculate position - center the window
        const containerRect = document.querySelector('.analytics-view')?.getBoundingClientRect() || { width: 800, height: 600 };
        const windowWidth = 700;
        const windowHeight = 500;
        const offset = (analyticsWindowCount - 1) * 30;
        const baseLeft = Math.max(80, (containerRect.width - windowWidth) / 2 + offset);
        const baseTop = Math.max(60, (containerRect.height - windowHeight) / 2 + offset);
        
        // Create window element
        const win = document.createElement('div');
        win.id = windowId;
        win.className = 'analytics-window';
        win.style.left = `${baseLeft}px`;
        win.style.top = `${baseTop}px`;
        win.style.width = windowWidth + 'px';
        win.style.height = windowHeight + 'px';
        
        safeSetInnerHTML(win, `
            <div class="analytics-window-header">
                <div class="analytics-window-icon">
                    <i data-lucide="bar-chart-2"></i>
                </div>
                <input type="text" class="analytics-window-title-input" 
                       value="${escapeHtml(name)}" 
                       placeholder="Query name..."
                       data-window-id="${windowId}">
                <div class="analytics-window-actions">
                    <button class="analytics-window-btn minimize" data-action="minimize" title="Minimize">
                        <i data-lucide="minus"></i>
                    </button>
                    <button class="analytics-window-btn maximize" data-action="maximize" title="Maximize">
                        <i data-lucide="maximize-2"></i>
                    </button>
                    <button class="analytics-window-btn close" data-action="close" title="Close">
                        <i data-lucide="x"></i>
                    </button>
                </div>
            </div>
            <div class="analytics-window-content">
                <div class="analytics-query-section">
                    <div class="analytics-query-header">
                        <span class="analytics-query-label">MQL Query</span>
                        <button class="analytics-run-btn" id="${windowId}-run">
                            <i data-lucide="play"></i>
                            <span>Run</span>
                        </button>
                    </div>
                    <textarea class="analytics-query-input" id="${windowId}-mql" 
                              placeholder="Enter MQL query...">${escapeHtml(initialMql || '')}</textarea>
                </div>
                <div class="analytics-result-section">
                    <div class="analytics-result-header">
                        <span class="analytics-result-label">Results</span>
                        <select class="analytics-output-type" id="${windowId}-output-type">
                            <option value="table" ${outputType === 'table' ? 'selected' : ''}>Table</option>
                            <option value="bar" ${outputType === 'bar' ? 'selected' : ''}>Bar Chart</option>
                            <option value="line" ${outputType === 'line' ? 'selected' : ''}>Line Chart</option>
                            <option value="pie" ${outputType === 'pie' ? 'selected' : ''}>Pie Chart</option>
                        </select>
                    </div>
                    <div class="analytics-result-container" id="${windowId}-result">
                        <div class="analytics-result-placeholder">
                            <i data-lucide="database"></i>
                            <span>Run a query to see results</span>
                        </div>
                    </div>
                </div>
            </div>
            <div class="analytics-window-resize"></div>
        `);
        
        // Add to container
        const container = document.getElementById('analytics-windows-container');
        if (container) {
            container.appendChild(win);
        }
        
        // Store window reference
        analyticsWindows[windowId] = {
            element: win,
            name: name,
            mql: initialMql,
            outputType: outputType
        };
        
        // Bind window events
        bindAnalyticsWindowEvents(win);
        
        // Initialize run button
        const runBtn = document.getElementById(`${windowId}-run`);
        if (runBtn) {
            runBtn.addEventListener('click', () => executeAnalyticsQuery(windowId));
        }
        
        // Bind title input change to update toolbar
        const titleInput = win.querySelector('.analytics-window-title-input');
        if (titleInput) {
            titleInput.addEventListener('change', (e) => {
                const newName = e.target.value.trim() || `Analytics ${analyticsWindowCount}`;
                analyticsWindows[windowId].name = newName;
                if (typeof ExplorerToolbar !== 'undefined' && ExplorerToolbar.updateAnalyticsInList) {
                    ExplorerToolbar.updateAnalyticsInList(windowId, newName);
                }
            });
            // Focus the title input for immediate editing
            setTimeout(() => titleInput.select(), 100);
        }
        
        // Add to toolbar list
        if (typeof ExplorerToolbar !== 'undefined' && ExplorerToolbar.addAnalyticsToList) {
            ExplorerToolbar.addAnalyticsToList(windowId, name);
        }
        
        // Update empty state
        updateAnalyticsEmptyState();
        
        // Initialize Lucide icons
        if (typeof lucide !== 'undefined') {
            setTimeout(() => lucide.createIcons(), 50);
        }
        
        // Focus the window
        bringAnalyticsWindowToFront(windowId);
        
        console.log(`[ExplorerTabs] Created analytics window: ${name}`);
    }
    
    function focusAnalyticsWindow(windowId) {
        const winData = analyticsWindows[windowId];
        if (winData && winData.element) {
            bringAnalyticsWindowToFront(windowId);
            winData.element.scrollIntoView({ behavior: 'smooth', block: 'center' });
        }
    }

    function bindAnalyticsWindowEvents(win) {
        const header = win.querySelector('.analytics-window-header');
        const resizeHandle = win.querySelector('.analytics-window-resize');
        const actions = win.querySelector('.analytics-window-actions');
        
        // Drag functionality
        header.addEventListener('mousedown', (e) => {
            if (e.target.closest('.analytics-window-actions')) return;
            
            e.preventDefault();
            const rect = win.getBoundingClientRect();
            analyticsDragState = {
                windowId: win.id,
                startX: e.clientX,
                startY: e.clientY,
                startLeft: rect.left,
                startTop: rect.top
            };
            win.classList.add('dragging');
            bringAnalyticsWindowToFront(win.id);
        });
        
        // Resize functionality
        resizeHandle.addEventListener('mousedown', (e) => {
            e.preventDefault();
            e.stopPropagation();
            const rect = win.getBoundingClientRect();
            analyticsResizeState = {
                windowId: win.id,
                startX: e.clientX,
                startY: e.clientY,
                startWidth: rect.width,
                startHeight: rect.height
            };
            win.classList.add('resizing');
        });
        
        // Window actions
        actions.addEventListener('click', (e) => {
            const btn = e.target.closest('.analytics-window-btn');
            if (!btn) return;
            
            const action = btn.dataset.action;
            switch (action) {
                case 'close':
                    closeAnalyticsWindow(win.id);
                    break;
                case 'minimize':
                    toggleMinimizeAnalyticsWindow(win.id);
                    break;
                case 'maximize':
                    toggleMaximizeAnalyticsWindow(win.id);
                    break;
            }
        });
        
        // Focus on click
        win.addEventListener('mousedown', () => {
            bringAnalyticsWindowToFront(win.id);
        });
    }

    // Global mouse event listeners for analytics windows
    document.addEventListener('mousemove', (e) => {
        if (analyticsDragState) {
            const dx = e.clientX - analyticsDragState.startX;
            const dy = e.clientY - analyticsDragState.startY;
            const win = document.getElementById(analyticsDragState.windowId);
            if (win) {
                win.style.left = `${analyticsDragState.startLeft + dx}px`;
                win.style.top = `${analyticsDragState.startTop + dy}px`;
            }
        }
        
        if (analyticsResizeState) {
            const dx = e.clientX - analyticsResizeState.startX;
            const dy = e.clientY - analyticsResizeState.startY;
            const win = document.getElementById(analyticsResizeState.windowId);
            if (win) {
                const newWidth = Math.max(400, analyticsResizeState.startWidth + dx);
                const newHeight = Math.max(300, analyticsResizeState.startHeight + dy);
                win.style.width = `${newWidth}px`;
                win.style.height = `${newHeight}px`;
            }
        }
    });

    document.addEventListener('mouseup', () => {
        if (analyticsDragState) {
            const win = document.getElementById(analyticsDragState.windowId);
            if (win) win.classList.remove('dragging');
            analyticsDragState = null;
        }
        
        if (analyticsResizeState) {
            const win = document.getElementById(analyticsResizeState.windowId);
            if (win) win.classList.remove('resizing');
            analyticsResizeState = null;
        }
    });

    function closeAnalyticsWindow(windowId) {
        const windowData = analyticsWindows[windowId];
        if (windowData && windowData.element) {
            windowData.element.remove();
            delete analyticsWindows[windowId];
        }
        
        // Remove from toolbar list
        if (typeof ExplorerToolbar !== 'undefined' && ExplorerToolbar.removeAnalyticsFromList) {
            ExplorerToolbar.removeAnalyticsFromList(windowId);
        }
        
        // Update empty state
        updateAnalyticsEmptyState();
    }

    function toggleMinimizeAnalyticsWindow(windowId) {
        const windowData = analyticsWindows[windowId];
        if (windowData && windowData.element) {
            windowData.element.classList.toggle('minimized');
        }
    }

    function toggleMaximizeAnalyticsWindow(windowId) {
        const windowData = analyticsWindows[windowId];
        if (windowData && windowData.element) {
            windowData.element.classList.toggle('maximized');
        }
    }

    function bringAnalyticsWindowToFront(windowId) {
        const allWindows = document.querySelectorAll('.analytics-window');
        let maxZ = 100;
        allWindows.forEach(w => {
            const z = parseInt(w.style.zIndex || 100);
            if (z > maxZ) maxZ = z;
        });
        
        const windowData = analyticsWindows[windowId];
        if (windowData) {
            windowData.element.style.zIndex = maxZ + 1;
        }
    }

    function executeAnalyticsQuery(windowId) {
        const mqlInput = document.getElementById(`${windowId}-mql`);
        const resultContainer = document.getElementById(`${windowId}-result`);
        const outputTypeSelect = document.getElementById(`${windowId}-output-type`);
        
        if (!mqlInput || !resultContainer) return;
        
        const mql = mqlInput.value.trim();
        const outputType = outputTypeSelect ? outputTypeSelect.value : 'table';
        
        if (!mql) {
            safeSetInnerHTML(resultContainer, `
                <div class="analytics-result-placeholder analytics-error">
                    <i data-lucide="alert-circle"></i>
                    <span>Please enter a query</span>
                </div>
            `);
            if (typeof lucide !== 'undefined') lucide.createIcons();
            return;
        }
        
        // Show loading state
        safeSetInnerHTML(resultContainer, `
            <div class="analytics-result-placeholder analytics-loading">
                <i data-lucide="loader"></i>
                <span>Executing query...</span>
            </div>
        `);
        if (typeof lucide !== 'undefined') lucide.createIcons();
        
        // Simulate query execution (replace with actual API call)
        setTimeout(() => {
            // Generate sample data
            const sampleData = generateSampleAnalyticsData();
            renderAnalyticsResult(windowId, sampleData, outputType);
        }, 800);
    }

    function generateSampleAnalyticsData() {
        // Generate sample data for demo
        const types = ['entity', 'process', 'event', 'artifact', 'resource'];
        const data = [];
        
        for (let i = 0; i < 10; i++) {
            data.push({
                id: `node_${i + 1}`,
                label: `Node ${i + 1}`,
                type: types[Math.floor(Math.random() * types.length)],
                count: Math.floor(Math.random() * 100) + 10,
                created: new Date(Date.now() - Math.random() * 30 * 24 * 60 * 60 * 1000).toISOString().split('T')[0]
            });
        }
        
        return data;
    }

    function renderAnalyticsResult(windowId, data, outputType) {
        const resultContainer = document.getElementById(`${windowId}-result`);
        if (!resultContainer) return;
        
        switch (outputType) {
            case 'table':
                renderAnalyticsTable(resultContainer, data);
                break;
            case 'bar':
            case 'line':
            case 'pie':
                renderAnalyticsChart(resultContainer, data, outputType);
                break;
            default:
                renderAnalyticsTable(resultContainer, data);
        }
    }

    function renderAnalyticsTable(container, data) {
        if (!data || data.length === 0) {
            safeSetInnerHTML(container, `
                <div class="analytics-result-placeholder">
                    <i data-lucide="inbox"></i>
                    <span>No results found</span>
                </div>
            `);
            if (typeof lucide !== 'undefined') lucide.createIcons();
            return;
        }
        
        const columns = Object.keys(data[0]);
        
        let html = `
            <div class="analytics-table-wrapper">
                <table class="analytics-table">
                    <thead>
                        <tr>
                            ${columns.map(col => `<th>${escapeHtml(col)}</th>`).join('')}
                        </tr>
                    </thead>
                    <tbody>
                        ${data.map(row => `
                            <tr>
                                ${columns.map(col => `<td>${escapeHtml(String(row[col] || ''))}</td>`).join('')}
                            </tr>
                        `).join('')}
                    </tbody>
                </table>
            </div>
            <div class="analytics-table-footer">
                <span>${data.length} rows</span>
            </div>
        `;
        
        safeSetInnerHTML(container, html);
    }

    function renderAnalyticsChart(container, data, chartType) {
        // Simple chart visualization using CSS/HTML
        // In production, you'd use a library like Chart.js or D3
        
        const maxCount = Math.max(...data.map(d => d.count || 0));
        
        let html = `<div class="analytics-chart analytics-chart-${chartType}">`;
        
        if (chartType === 'pie') {
            // Pie chart - aggregate by type
            const byType = {};
            data.forEach(d => {
                byType[d.type] = (byType[d.type] || 0) + (d.count || 1);
            });
            
            const total = Object.values(byType).reduce((a, b) => a + b, 0);
            const colors = ['#555555', '#777777', '#999999', '#bbbbbb', '#dddddd'];
            let colorIndex = 0;
            
            html += `<div class="pie-legend">`;
            for (const [type, count] of Object.entries(byType)) {
                const pct = ((count / total) * 100).toFixed(1);
                html += `
                    <div class="pie-legend-item">
                        <span class="pie-legend-color" style="background: ${colors[colorIndex % colors.length]}"></span>
                        <span class="pie-legend-label">${escapeHtml(type)}</span>
                        <span class="pie-legend-value">${pct}%</span>
                    </div>
                `;
                colorIndex++;
            }
            html += `</div>`;
            html += `<div class="pie-chart-placeholder">
                <i data-lucide="pie-chart"></i>
                <span>Pie chart visualization</span>
            </div>`;
        } else {
            // Bar or Line chart
            html += `<div class="chart-bars">`;
            data.slice(0, 8).forEach((d, i) => {
                const height = maxCount > 0 ? ((d.count || 0) / maxCount) * 100 : 0;
                html += `
                    <div class="chart-bar-wrapper">
                        <div class="chart-bar" style="height: ${height}%" title="${d.label}: ${d.count}">
                            <span class="chart-bar-value">${d.count}</span>
                        </div>
                        <span class="chart-bar-label">${escapeHtml(d.label || `Item ${i}`)}</span>
                    </div>
                `;
            });
            html += `</div>`;
        }
        
        html += `</div>`;
        safeSetInnerHTML(container, html);
        
        if (typeof lucide !== 'undefined') lucide.createIcons();
    }

    // ============================================
    // Artefacts Tab - Window Management
    // ============================================
    let artefactsWindows = {};
    let artefactsWindowCount = 0;

    function initArtefactsTab() {
        console.log('[ExplorerTabs] initArtefactsTab called');
        
        // Use requestAnimationFrame to ensure DOM is updated
        requestAnimationFrame(() => {
            // Bind empty state create button - opens Templates window
            const emptyCreateBtn = document.getElementById('artefacts-empty-create-btn');
            console.log('[ExplorerTabs] Found empty create btn:', emptyCreateBtn);
            if (emptyCreateBtn && !emptyCreateBtn.dataset.bound) {
                emptyCreateBtn.addEventListener('click', (e) => {
                    e.preventDefault();
                    e.stopPropagation();
                    console.log('[ExplorerTabs] Browse Templates clicked - opening window');
                    if (typeof ExplorerWindows !== 'undefined') {
                        ExplorerWindows.toggle('templates');
                    }
                });
                emptyCreateBtn.dataset.bound = 'true';
                console.log('[ExplorerTabs] Button bound successfully');
            }
            
            // Initialize Lucide icons
            if (typeof lucide !== 'undefined') {
                lucide.createIcons();
            }
            
            // Update empty state visibility
            updateArtefactsEmptyState();
        });
    }

    function updateArtefactsEmptyState() {
        const emptyState = document.getElementById('artefacts-empty-state');
        const hasWindows = Object.keys(artefactsWindows).length > 0;
        
        if (emptyState) {
            emptyState.classList.toggle('hidden', hasWindows);
            emptyState.style.display = hasWindows ? 'none' : 'flex';
        }
    }

    function createArtefactWindow(template) {
        artefactsWindowCount++;
        const windowId = `artefact-window-${artefactsWindowCount}`;
        
        // Calculate position - offset for each window
        const windowWidth = 420;
        const windowHeight = 380;
        const offset = (artefactsWindowCount - 1) * 25;
        const baseLeft = 100 + offset;
        const baseTop = 80 + offset;
        
        const categoryIcons = {
            'slide_deck': 'presentation',
            'book': 'book-open',
            'podcast': 'mic',
            'video': 'video',
            'dashboard': 'layout-dashboard',
            'website': 'globe',
            'custom': 'file-text'
        };
        const icon = categoryIcons[template.mixin_name] || 'file-text';
        
        const win = document.createElement('div');
        win.id = windowId;
        win.className = 'artefact-window';
        win.style.left = `${baseLeft}px`;
        win.style.top = `${baseTop}px`;
        win.style.width = windowWidth + 'px';
        win.style.height = windowHeight + 'px';
        
        safeSetInnerHTML(win, `
            <div class="artefact-window-header">
                <div class="artefact-window-icon ${template.mixin_name}">
                    <i data-lucide="${icon}"></i>
                </div>
                <input type="text" class="artefact-window-title-input" 
                       value="${escapeHtml(template.name)}" 
                       placeholder="Artefact name..."
                       data-window-id="${windowId}">
                <div class="artefact-window-actions">
                    <button class="artefact-window-btn minimize" data-action="minimize" title="Minimize">
                        <i data-lucide="minus"></i>
                    </button>
                    <button class="artefact-window-btn maximize" data-action="maximize" title="Maximize">
                        <i data-lucide="maximize-2"></i>
                    </button>
                    <button class="artefact-window-btn close" data-action="close" title="Close">
                        <i data-lucide="x"></i>
                    </button>
                </div>
            </div>
            <div class="artefact-window-content">
                <div class="artefact-config-section">
                    <div class="artefact-template-info">
                        <span class="artefact-template-type">${escapeHtml(template.mixin_name.replace('_', ' '))}</span>
                        <p class="artefact-template-desc">${escapeHtml(template.description || '')}</p>
                    </div>
                    <div class="artefact-params-section">
                        <h5>Parameters</h5>
                        <div class="artefact-params-form" id="${windowId}-params">
                            <div class="artefact-param-field">
                                <label>Title</label>
                                <input type="text" placeholder="Enter title..." class="artefact-param-input">
                            </div>
                            <div class="artefact-param-field">
                                <label>Description</label>
                                <textarea placeholder="Enter description..." class="artefact-param-textarea" rows="2"></textarea>
                            </div>
                            <div class="artefact-param-field">
                                <label>Data Source</label>
                                <select class="artefact-param-select">
                                    <option value="graph">Current Graph Selection</option>
                                    <option value="query">MQL Query Result</option>
                                    <option value="manual">Manual Input</option>
                                </select>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="artefact-preview-section">
                    <div class="artefact-preview-header">
                        <span>Preview</span>
                        <button class="artefact-generate-btn" id="${windowId}-generate">
                            <i data-lucide="sparkles"></i>
                            <span>Generate</span>
                        </button>
                    </div>
                    <div class="artefact-preview-container" id="${windowId}-preview">
                        <div class="artefact-preview-placeholder">
                            <i data-lucide="file-text"></i>
                            <span>Configure parameters and click Generate to preview</span>
                        </div>
                    </div>
                </div>
            </div>
            <div class="artefact-window-resize"></div>
        `);
        
        // Add to container
        const container = document.getElementById('artefacts-windows-container');
        if (container) {
            container.appendChild(win);
        }
        
        // Store window reference
        artefactsWindows[windowId] = {
            element: win,
            template: template,
            name: template.name
        };
        
        // Bind window events
        bindArtefactWindowEvents(win);
        
        // Bind generate button
        const generateBtn = document.getElementById(`${windowId}-generate`);
        if (generateBtn) {
            generateBtn.addEventListener('click', () => generateArtefactPreview(windowId));
        }
        
        // Add to toolbar list
        if (typeof ExplorerToolbar !== 'undefined' && ExplorerToolbar.addArtefactToList) {
            ExplorerToolbar.addArtefactToList(windowId, template.name);
        }
        
        // Update empty state
        updateArtefactsEmptyState();
        
        // Initialize Lucide icons
        if (typeof lucide !== 'undefined') {
            setTimeout(() => lucide.createIcons(), 50);
        }
        
        console.log(`[ExplorerTabs] Created artefact window: ${template.name}`);
    }

    function bindArtefactWindowEvents(win) {
        const header = win.querySelector('.artefact-window-header');
        const actions = win.querySelector('.artefact-window-actions');
        const resizeHandle = win.querySelector('.artefact-window-resize');
        
        // Bring to front on click
        win.addEventListener('mousedown', () => {
            document.querySelectorAll('.artefact-window').forEach(w => w.style.zIndex = '100');
            win.style.zIndex = '101';
        });
        
        // Action buttons
        actions.addEventListener('click', (e) => {
            const btn = e.target.closest('.artefact-window-btn');
            if (!btn) return;
            
            const action = btn.dataset.action;
            const windowId = win.id;
            
            switch (action) {
                case 'minimize':
                    win.classList.toggle('minimized');
                    break;
                case 'maximize':
                    win.classList.toggle('maximized');
                    break;
                case 'close':
                    closeArtefactWindow(windowId);
                    break;
            }
        });
        
        // Drag functionality
        let isDragging = false;
        let startX, startY, startLeft, startTop;
        
        header.addEventListener('mousedown', (e) => {
            if (e.target.closest('.artefact-window-actions') || e.target.closest('input')) return;
            isDragging = true;
            startX = e.clientX;
            startY = e.clientY;
            startLeft = win.offsetLeft;
            startTop = win.offsetTop;
            win.classList.add('dragging');
            e.preventDefault();
        });
        
        // Resize functionality
        let isResizing = false;
        let startWidth, startHeight;
        
        if (resizeHandle) {
            resizeHandle.addEventListener('mousedown', (e) => {
                isResizing = true;
                startX = e.clientX;
                startY = e.clientY;
                startWidth = win.offsetWidth;
                startHeight = win.offsetHeight;
                win.classList.add('resizing');
                e.preventDefault();
                e.stopPropagation();
            });
        }
        
        document.addEventListener('mousemove', (e) => {
            if (isDragging) {
                const dx = e.clientX - startX;
                const dy = e.clientY - startY;
                win.style.left = Math.max(0, startLeft + dx) + 'px';
                win.style.top = Math.max(0, startTop + dy) + 'px';
            }
            if (isResizing) {
                const dx = e.clientX - startX;
                const dy = e.clientY - startY;
                win.style.width = Math.max(300, startWidth + dx) + 'px';
                win.style.height = Math.max(200, startHeight + dy) + 'px';
            }
        });
        
        document.addEventListener('mouseup', () => {
            if (isDragging) {
                isDragging = false;
                win.classList.remove('dragging');
            }
            if (isResizing) {
                isResizing = false;
                win.classList.remove('resizing');
            }
        });
    }

    function closeArtefactWindow(windowId) {
        const windowData = artefactsWindows[windowId];
        if (windowData && windowData.element) {
            windowData.element.remove();
            delete artefactsWindows[windowId];
        }
        
        // Remove from toolbar list
        if (typeof ExplorerToolbar !== 'undefined' && ExplorerToolbar.removeArtefactFromList) {
            ExplorerToolbar.removeArtefactFromList(windowId);
        }
        
        // Update empty state
        updateArtefactsEmptyState();
    }

    function generateArtefactPreview(windowId) {
        const preview = document.getElementById(`${windowId}-preview`);
        if (!preview) return;
        
        // Show loading
        safeSetInnerHTML(preview, `
            <div class="artefact-preview-placeholder loading">
                <i data-lucide="loader"></i>
                <span>Generating preview...</span>
            </div>
        `);
        if (typeof lucide !== 'undefined') lucide.createIcons();
        
        // Simulate generation (replace with actual API call)
        setTimeout(() => {
            safeSetInnerHTML(preview, `
                <div class="artefact-preview-content">
                    <div class="preview-section">
                        <h3>Generated Content Preview</h3>
                        <p>This is a sample preview of the generated content based on your parameters and selected data source.</p>
                        <ul>
                            <li>Section 1: Introduction</li>
                            <li>Section 2: Key Findings</li>
                            <li>Section 3: Analysis</li>
                            <li>Section 4: Conclusions</li>
                        </ul>
                    </div>
                    <div class="preview-actions">
                        <button class="preview-action-btn">
                            <i data-lucide="download"></i>
                            Export
                        </button>
                        <button class="preview-action-btn">
                            <i data-lucide="edit"></i>
                            Edit
                        </button>
                    </div>
                </div>
            `);
            if (typeof lucide !== 'undefined') lucide.createIcons();
        }, 1500);
    }

    // ============================================
    // Graph Content Management
    // ============================================

    function hideGraphContent(animate, keepWindows = false, keepNetwork = false) {
        const { network, timeline, windows } = contentContainers['graph'];
        // NOTE: Toolbar stays visible across all tabs
        
        // Keep network visible for tabs that share it (e.g., Bookmarks)
        if (network && !keepNetwork) {
            if (animate) {
                network.style.transition = 'opacity 0.3s ease, transform 0.3s ease';
                network.style.opacity = '0';
                network.style.transform = 'scale(0.98)';
                setTimeout(() => {
                    network.style.display = 'none';
                }, 300);
            } else {
                network.style.display = 'none';
                network.style.opacity = '0';
            }
        }
        
        if (timeline) {
            timeline.classList.add('hidden');
        }
        
        // Keep floating windows visible for tabs that use them (e.g., Bookmarks)
        if (windows && !keepWindows) {
            windows.style.display = 'none';
        }
    }

    function showGraphContent(animate) {
        const { network, timeline, windows } = contentContainers['graph'];
        // NOTE: Toolbar stays visible across all tabs
        
        if (network) {
            network.style.display = 'block';
            if (animate) {
                requestAnimationFrame(() => {
                    network.style.transition = 'opacity 0.3s ease, transform 0.3s ease';
                    network.style.opacity = '1';
                    network.style.transform = 'scale(1)';
                });
            } else {
                network.style.opacity = '1';
                network.style.transform = 'scale(1)';
            }
        }
        
        // Timeline visibility is controlled by its own toggle
        // Don't auto-show it
        
        if (windows) {
            windows.style.display = 'block';
        }
    }
    
    /**
     * Show only floating windows (for tabs like Bookmarks that share them with Graph)
     */
    function showFloatingWindows() {
        const { windows } = contentContainers['graph'];
        if (windows) {
            windows.style.display = 'block';
        }
    }

    function hideTabContent(container, animate) {
        if (animate) {
            container.style.transition = 'opacity 0.3s ease, transform 0.3s ease';
            container.style.opacity = '0';
            container.style.transform = 'scale(0.98)';
            setTimeout(() => {
                container.style.display = 'none';
            }, 300);
        } else {
            container.style.display = 'none';
            container.style.opacity = '0';
        }
    }

    function showTabContent(container, animate) {
        container.style.display = 'flex';
        if (animate) {
            requestAnimationFrame(() => {
                container.style.transition = 'opacity 0.3s ease, transform 0.3s ease';
                container.style.opacity = '1';
                container.style.transform = 'scale(1)';
            });
        } else {
            container.style.opacity = '1';
            container.style.transform = 'scale(1)';
        }
    }

    function announceTabChange(tabId) {
        const tab = tabs.find(t => t.id === tabId);
        if (tab && typeof GraphExplorer !== 'undefined' && ExplorerUtils.announceChange) {
            ExplorerUtils.announceChange(`Switched to ${tab.label} view`);
        }
    }

    // ============================================
    // Public API
    // ============================================
    function getActiveTab() {
        return activeTab;
    }

    function getTabs() {
        return [...tabs];
    }

    // ============================================
    // Bottom Sub-Tabs Bar  (Checkpoints / Bookmarks)
    // ============================================

    /**
     * Create the bottom sub-tabs container inside #bottom-bar-container.
     */
    function createBottomSubtabs() {
        const host = document.getElementById('bottom-bar-container');
        if (!host) return;

        bottomBar = document.createElement('div');
        bottomBar.id = 'bottom-subtabs';
        bottomBar.className = 'bottom-subtabs hidden';
        bottomBar.setAttribute('role', 'toolbar');
        bottomBar.setAttribute('aria-label', 'Checkpoints and bookmarks');
        host.appendChild(bottomBar);
    }

    /**
     * Decide what to show in the bottom bar based on the active tab.
     *  - Graph tab           → checkpoints
     *  - Bookmarks/Timeline/Analytics → bookmarks
     *  - Other tabs           → hidden
     */
    function updateBottomSubtabs(tabId) {
        if (!bottomBar) return;

        if (tabId === 'graph') {
            renderBottomItems('checkpoints', bottomCheckpoints);
        } else if (['bookmarks', 'timeline', 'analytics'].includes(tabId)) {
            renderBottomItems('bookmarks', bottomBookmarks);
        } else {
            bottomBar.classList.add('hidden');
        }
    }

    /**
     * Render pill items inside the bottom bar.
     * @param {'checkpoints'|'bookmarks'} kind
     * @param {Array} items  - [{name: string}, ...]
     */
    function renderBottomItems(kind, items) {
        if (!bottomBar) return;

        const isCheckpoint = kind === 'checkpoints';
        const icon = isCheckpoint ? 'flag' : 'bookmark';
        const label = isCheckpoint ? 'Checkpoints' : 'Bookmarks';
        const actionAttr = isCheckpoint ? 'data-checkpoint' : 'data-bookmark';
        const actionName = isCheckpoint ? 'restoreCheckpoint' : 'useBookmark';

        let html = `<span class="bottom-subtabs-label"><i data-lucide="${icon}"></i>${label}</span>`;

        if (!items || items.length === 0) {
            html += `<span class="bottom-subtabs-empty">None yet</span>`;
        } else {
            const activeName = isCheckpoint ? activeCheckpointName : activeBookmarkName;
            items.forEach(item => {
                const name = item.name || item;
                const escaped = escapeHtmlTabs(name);
                const isActive = (activeName && name === activeName) ? ' active' : '';
                html += `
                    <button type="button" class="bottom-subtab-item${isActive}"
                        data-action="${actionName}"
                        ${actionAttr}="${escaped}"
                        title="${isCheckpoint ? 'Restore' : 'Load'}: ${escaped}">
                        <i data-lucide="${icon}"></i>
                        ${escaped}
                    </button>`;
            });
        }

        safeSetInnerHTML(bottomBar, html);
        bottomBar.classList.remove('hidden');

        // Lucide icons
        if (typeof lucide !== 'undefined') {
            setTimeout(() => lucide.createIcons(), 10);
        }

        // Bind click handlers
        bottomBar.querySelectorAll('.bottom-subtab-item').forEach(btn => {
            btn.addEventListener('click', handleBottomItemClick);
        });
    }

    function handleBottomItemClick(e) {
        const btn = e.currentTarget;
        const action = btn.dataset.action;
        const name = btn.dataset.checkpoint || btn.dataset.bookmark;
        if (!name) return;

        if (typeof ExplorerAPI === 'undefined') return;

        // Mark as active immediately
        if (action === 'restoreCheckpoint') {
            activeCheckpointName = name;
        } else {
            activeBookmarkName = name;
        }
        // Update visual state
        bottomBar.querySelectorAll('.bottom-subtab-item').forEach(b => {
            const bName = b.dataset.checkpoint || b.dataset.bookmark;
            b.classList.toggle('active', bName === name);
        });

        const emitPointerActivated = () => {
            const detail = action === 'restoreCheckpoint'
                ? { kind: 'checkpoint', name, snapshotKey: `checkpoint:${name}` }
                : { kind: 'bookmark', name, snapshotKey: `bookmark:${name}` };
            document.dispatchEvent(new CustomEvent('explorer:pointerActivated', { detail }));
        };

        if (action === 'useBookmark' && ExplorerAPI.previewPointerGraph) {
            ExplorerAPI.previewPointerGraph('bookmark', name, { switchTab: false })
                .then((data) => {
                    if (data && !data.error) {
                        emitPointerActivated();
                    } else {
                        throw new Error(data?.error || 'Failed to load bookmark');
                    }
                })
                .catch(err => console.error('[ExplorerTabs] Bottom bar bookmark preview failed:', err));
            return;
        }

        if (!ExplorerAPI.executeMQL) return;

        let query;
        if (action === 'restoreCheckpoint') {
            query = `RESTORE('${name.replace(/'/g, "''")}');`;
        } else {
            query = `USE BOOKMARK('${name.replace(/'/g, "''")}');`;
        }

        ExplorerAPI.executeMQL(query)
            .then(() => {
                if (ExplorerAPI.refreshGraph) ExplorerAPI.refreshGraph(true);
                emitPointerActivated();
            })
            .catch(err => console.error('[ExplorerTabs] Bottom bar action failed:', err));
    }

    /**
     * Called when checkpoint data arrives (from _refreshSideData or toolbar).
     * @param {Array|undefined} list - checkpoint array, or undefined to keep existing data
     * @param {string} [activeName] - which checkpoint to mark active
     */
    function setCheckpoints(list, activeName) {
        if (list !== undefined) bottomCheckpoints = list || [];
        if (activeName !== undefined) activeCheckpointName = activeName;
        if (bottomBarOnly) {
            return;
        }
        if (activeTab === 'graph') {
            renderBottomItems('checkpoints', bottomCheckpoints);
        }
    }

    /**
     * Called when bookmark data arrives (from _refreshSideData or toolbar).
     * @param {Array|undefined} list - bookmark array, or undefined to keep existing data
     * @param {string} [activeName] - which bookmark to mark active
     */
    function setBookmarks(list, activeName) {
        if (list !== undefined) bottomBookmarks = list || [];
        if (activeName !== undefined) activeBookmarkName = activeName;
        if (bottomBarOnly) {
            if (bottomBookmarks.length > 0) {
                renderBottomItems('bookmarks', bottomBookmarks);
            }
            return;
        }
        if (['bookmarks', 'timeline', 'analytics'].includes(activeTab)) {
            renderBottomItems('bookmarks', bottomBookmarks);
        } else if (activeTab === 'graph' && bottomBookmarks.length > 0 && activeBookmarkName) {
            renderBottomItems('bookmarks', bottomBookmarks);
        }
    }

    function escapeHtmlTabs(text) {
        if (!text) return '';
        const div = document.createElement('div');
        div.textContent = text;
        return div.innerHTML;
    }

    // Export module
    global.ExplorerTabs = {
        init,
        initBottomBar,
        switchTab,
        getActiveTab,
        getTabs,
        focusTimelineWindow,
        focusAnalyticsWindow,
        createTimelineWindow,
        createAnalyticsWindow,
        createArtefactWindow,
        setCheckpoints,
        setBookmarks
    };

})(window);
